import { render, staticRenderFns } from "./cardV3.vue?vue&type=template&id=569d98fa&scoped=true"
import script from "./cardV3.vue?vue&type=script&lang=js"
export * from "./cardV3.vue?vue&type=script&lang=js"
import style0 from "./cardV3.vue?vue&type=style&index=0&id=569d98fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "569d98fa",
  null
  
)

export default component.exports